import {
  Actions,
  GET_JOIN_REQUESTS_FOR_TEAM,
  GET_JOIN_REQUESTS_FOR_TEAM_SUCCEEDED,
  GET_JOIN_REQUESTS_FOR_TEAM_FAILED,
  GET_JOIN_REQUESTS_FOR_ALL_TEAMS,
  GET_JOIN_REQUESTS_FOR_ALL_TEAMS_FAILED,
  GET_JOIN_REQUESTS_FOR_ALL_TEAMS_SUCCEEDED,
  GET_PROJECT_JOIN_REQUESTS,
  GET_PROJECT_JOIN_REQUESTS_SUCCEEDED,
  GET_PROJECT_JOIN_REQUESTS_FAILED,
  GET_USER_PENDING_TEAM_REQUESTS_SUCCEEDED,
  GET_USER_PENDING_PROJECT_REQUESTS,
  GET_USER_PENDING_PROJECT_REQUESTS_FAILED,
  GET_USER_PENDING_PROJECT_REQUESTS_SUCCEEDED,
  ACCEPT_JOIN_REQUEST,
  REJECT_JOIN_REQUEST,
  ACCEPT_JOIN_REQUEST_SUCCEEDED,
  ACCEPT_JOIN_REQUEST_FAILED,
  REJECT_JOIN_REQUEST_FAILED,
  REJECT_JOIN_REQUEST_SUCCEEDED,
  GET_USER_PROJECTS_JOIN_REQUESTS,
  GET_USER_PROJECTS_JOIN_REQUESTS_SUCCEEDED,
  GET_USER_PROJECTS_JOIN_REQUESTS_FAILED,
  CLEAR_JOIN_REQUESTS_REDUCER_BY_KEY,
  GET_JOIN_REQUESTS_FOR_NOTIFICATIONS,
  GET_JOIN_REQUESTS_FOR_NOTIFICATIONS_SUCCEEDED,
} from './actions';
import { IJoinRequestsState } from './types';

const initialState: IJoinRequestsState = {
  teamJoinRequestsList: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
    total: null,
  },
  allTeamsJoinRequestsList: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
    total: null,
  },
  projectJoinRequestsList: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
    total: null,
  },
  userPendingTeamRequestsMap: {},
  joinRequestBeingResponded: null,
  userProjectsJoinRequestsList: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
    total: null,
  },
  loadingUserPendingProjectRequests: false,
  userPendingProjectRequestsMap: {},
  notificationRequestTotals: {
    projectRequestsTotal: null,
    teamRequestsTotal: null,
  },
};

const reducer = (
  state: IJoinRequestsState = initialState,
  action: Actions
): IJoinRequestsState => {
  switch (action.type) {
    case GET_JOIN_REQUESTS_FOR_TEAM:
      return {
        ...state,
        teamJoinRequestsList: {
          ...state.teamJoinRequestsList,
          loading: true,
        },
      };

    case GET_JOIN_REQUESTS_FOR_TEAM_SUCCEEDED:
      return {
        ...state,
        teamJoinRequestsList: {
          items: action.payload.shouldAppend
            ? [
                ...state.allTeamsJoinRequestsList.items,
                ...action.payload.joinRequests,
              ]
            : action.payload.joinRequests,
          loading: false,
          queriedAtLeastOnce: true,
          total: action.payload.total,
        },
      };

    case GET_JOIN_REQUESTS_FOR_TEAM_FAILED:
      return {
        ...state,
        teamJoinRequestsList: {
          ...state.teamJoinRequestsList,
          loading: false,
        },
      };

    case GET_JOIN_REQUESTS_FOR_ALL_TEAMS:
      return {
        ...state,
        allTeamsJoinRequestsList: {
          ...state.allTeamsJoinRequestsList,
          loading: true,
        },
      };

    case GET_JOIN_REQUESTS_FOR_ALL_TEAMS_SUCCEEDED:
      return {
        ...state,
        allTeamsJoinRequestsList: {
          total: action.payload.total,
          items: action.payload.shouldAppend
            ? [...state.allTeamsJoinRequestsList.items, ...action.payload.items]
            : action.payload.items,
          loading: false,
          queriedAtLeastOnce: true,
        },
      };

    case GET_JOIN_REQUESTS_FOR_ALL_TEAMS_FAILED:
      return {
        ...state,
        allTeamsJoinRequestsList: {
          ...state.teamJoinRequestsList,
          loading: false,
        },
      };

    case GET_USER_PENDING_TEAM_REQUESTS_SUCCEEDED:
      return {
        ...state,
        userPendingTeamRequestsMap: action.payload,
      };

    case GET_USER_PENDING_PROJECT_REQUESTS:
      return {
        ...state,
        loadingUserPendingProjectRequests: true,
        userPendingProjectRequestsMap: action.payload.projectId
          ? {}
          : state.userPendingProjectRequestsMap,
      };

    case GET_USER_PENDING_PROJECT_REQUESTS_SUCCEEDED:
      return {
        ...state,
        loadingUserPendingProjectRequests: false,
        userPendingProjectRequestsMap: action.payload,
      };

    case GET_USER_PENDING_PROJECT_REQUESTS_FAILED:
      return {
        ...state,
        loadingUserPendingProjectRequests: false,
      };

    case GET_PROJECT_JOIN_REQUESTS:
      return {
        ...state,
        projectJoinRequestsList: {
          items: [],
          loading: true,
          queriedAtLeastOnce: true,
        },
      };

    case GET_PROJECT_JOIN_REQUESTS_SUCCEEDED:
      return {
        ...state,
        projectJoinRequestsList: {
          items: action.payload.shouldAppend
            ? [
                ...state.projectJoinRequestsList.items,
                ...action.payload.joinRequests,
              ]
            : action.payload.joinRequests,
          loading: false,
          queriedAtLeastOnce: true,
          total: action.payload.total,
        },
      };

    case GET_PROJECT_JOIN_REQUESTS_FAILED:
      return {
        ...state,
        projectJoinRequestsList: {
          items: [],
          loading: false,
          queriedAtLeastOnce: true,
        },
      };

    case ACCEPT_JOIN_REQUEST:
    case REJECT_JOIN_REQUEST:
      return {
        ...state,
        joinRequestBeingResponded: action.payload.id,
      };

    case ACCEPT_JOIN_REQUEST_FAILED:
    case ACCEPT_JOIN_REQUEST_SUCCEEDED:
    case REJECT_JOIN_REQUEST_FAILED:
    case REJECT_JOIN_REQUEST_SUCCEEDED:
      return {
        ...state,
        joinRequestBeingResponded: null,
      };

    case GET_USER_PROJECTS_JOIN_REQUESTS:
      return {
        ...state,
        userProjectsJoinRequestsList: {
          ...state.userProjectsJoinRequestsList,
          loading: true,
        },
      };

    case GET_USER_PROJECTS_JOIN_REQUESTS_SUCCEEDED:
      return {
        ...state,
        userProjectsJoinRequestsList: {
          ...state.userProjectsJoinRequestsList,
          total: action.payload.total,
          items: action.payload.shouldAppend
            ? [
                ...state.userProjectsJoinRequestsList.items,
                ...action.payload.items,
              ]
            : action.payload.items,
          loading: false,
        },
      };

    case GET_USER_PROJECTS_JOIN_REQUESTS_FAILED:
      return {
        ...state,
        userProjectsJoinRequestsList: {
          items: [],
          loading: false,
          queriedAtLeastOnce: false,
        },
      };

    case GET_JOIN_REQUESTS_FOR_NOTIFICATIONS: {
      return {
        ...state,
        notificationRequestTotals: {
          ...state.notificationRequestTotals,
        },
      };
    }
    case GET_JOIN_REQUESTS_FOR_NOTIFICATIONS_SUCCEEDED: {
      return {
        ...state,
        notificationRequestTotals: {
          ...action.payload,
        },
      };
    }

    case CLEAR_JOIN_REQUESTS_REDUCER_BY_KEY:
      return {
        ...state,
        [action.payload]: initialState[action.payload],
      };

    default:
      return state;
  }
};

export default reducer;
